import { faBrush } from '@fortawesome/pro-solid-svg-icons/faBrush';
import { faSave } from '@fortawesome/pro-solid-svg-icons/faSave';
import { createSignature } from '@ukpostbox/client-data';
import { Button, ColourStateSolid, FlexGap, StackVertical } from '@ukpostbox/frontend-framework';
import { useEffect, useRef } from 'react';

type DrawSignatureType = {
	createdCallback: (id: number, base64: string) => void;
};

function DrawSignature(props: DrawSignatureType) {
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const ctx = useRef<any>(null);

	let drawingActive = false;
	let startLine = false;

	let prevX = 0;
	let prevY = 0;

	let currX = 0;
	let currY = 0;

	const colour = 'black';
	const thickness = 4;

	const ClearCanvas = () => {
		ctx.current.clearRect(0, 0, canvasRef.current?.width, canvasRef.current?.height);
	};

	const Draw = () => {
		ctx.current.beginPath();
		ctx.current.moveTo(prevX, prevY);
		ctx.current.lineTo(currX, currY);
		ctx.current.strokeStyle = colour;
		ctx.current.lineCap = 'round';
		ctx.current.lineWidth = thickness;
		ctx.current.stroke();
		ctx.current.closePath();
	};

	const GetPosition = (action: string, event: MouseEvent) => {
		if (canvasRef.current) {
			const canvasRect = canvasRef.current.getBoundingClientRect();
			switch (action) {
				case 'down':
					prevX = currX;
					prevY = currY;
					currX = event.clientX - canvasRect.left;
					currY = event.clientY - canvasRect.top;

					drawingActive = true;
					startLine = true;

					if (startLine) {
						ctx.current.beginPath();
						ctx.current.fillStyle = colour;
						ctx.current.fillRect(currX, currY, 2, 2);
						ctx.current.closePath();
						startLine = false;
					}
					break;
				case 'move':
					if (drawingActive) {
						prevX = currX;
						prevY = currY;
						currX = event.clientX - canvasRect.left;
						currY = event.clientY - canvasRect.top;
						Draw();
					}
					break;
				case 'up':
				default:
					drawingActive = false;
					break;
			}
		}
	};

	const HandleMouseMove = (e: MouseEvent) => {
		GetPosition('move', e);
	};

	const HandleMouseDown = (e: MouseEvent) => {
		GetPosition('down', e);
	};

	const HandleMouseUp = (e: MouseEvent) => {
		GetPosition('up', e);
	};

	const HandleSave = () => {
		const dataUrl = canvasRef.current?.toDataURL();
		if (dataUrl) {
			createSignature(dataUrl).then((r) => {
				props.createdCallback(r.id, dataUrl);
			});
		}
	};

	useEffect(() => {
		if (canvasRef.current) {
			ctx.current = canvasRef.current.getContext('2d');
		}
	}, [canvasRef.current]);

	return (
		<div className='draw-signature-container'>
			<canvas
				ref={canvasRef}
				width={500}
				height={200}
				onMouseMove={(e: any) => HandleMouseMove(e)}
				onMouseDown={(e: any) => HandleMouseDown(e)}
				onMouseUp={(e: any) => HandleMouseUp(e)}
				onTouchMove={(e: any) => HandleMouseMove(e)}
				onTouchStart={(e: any) => HandleMouseDown(e)}
				onTouchEnd={(e: any) => HandleMouseUp(e)}
			/>

			<StackVertical gap={FlexGap.Small}>
				<Button
					title='Save'
					colour={ColourStateSolid.Primary}
					icon={faSave}
					squared
					onClick={() => HandleSave()}
				/>
				<Button title='Clear' icon={faBrush} squared onClick={() => ClearCanvas()} />
			</StackVertical>
		</div>
	);
}

export { DrawSignature };
